export const ENV_CONFIG = (window as Window & {configOverride?: Record<string, unknown>})?.configOverride;

export const DEFAULT_CONFIG = {
  baseApiUrl: 'https://api-sep.medadstg.com',
  designerBaseApiUrl: 'https://api-sep.medadstg.com',
  defaultAppLang: 'en',
  tenant: 'medad',
  ssoConfigs: {
    url: 'https://sso.medadstg.com/realms/medad',
    clientId: 'sep-client',
  },
} as const;
